<template>
  <div id="contact" class="form" :class="$mq">
    <h3>{{ $t("step4.title") }}</h3>
    <div class="section" :class="$mq">
      <div class="title">{{ $t("step4.contact.title") }}</div>
      <div class="container inline h-item-margin">
        <label for="civility">
          <h4>{{ $t("step4.contact.civility") }}</h4>
          <select
            id="civility"
            name="civility"
            v-model="civility"
            class="input"
            :disabled="!civilities.length"
          >
            <option v-for="item in civilities" :key="item">{{ item }}</option>
          </select>
        </label>
      </div>
      <ValidationObserver ref="observer" v-slot="{ valid }" slim>
        <div class="container inline top">
          <label for="firstName">
            <h4>{{ $t("step4.contact.firstName") }}</h4>
            <ValidationProvider rules="required" v-slot="{ errors }" :disabled="!consent">
              <input
                type="text"
                id="firstName"
                v-model="firstName"
                name="firstName"
                class="input"
                @change="consent = true"
              />
              <span class="input-error" v-if="consent">{{ errors[0] }}</span>
            </ValidationProvider>
          </label>
          <label for="lastName">
            <h4>{{ $t("step4.contact.lastName") }}</h4>
            <ValidationProvider rules="required" v-slot="{ errors }" :disabled="!consent">
              <input
                type="text"
                id="lastName"
                v-model="lastName"
                name="lastName"
                class="input"
                @change="consent = true"
              />
              <span class="input-error" v-if="consent">{{ errors[0] }}</span>
            </ValidationProvider>
          </label>
        </div>

        <div class="container inline">
          <label for="phone">
            <h4>{{ $t("step4.contact.phone") }}</h4>
            <ValidationProvider
              :rules="{required: mail && mail.length === 0, numeric: true}"
              v-slot="{ errors }"
              :disabled="!consent"
              :customMessages="{ required: $t('step4.contact.required')}"
            >
              <input
                type="text"
                id="phone"
                v-model="phone"
                name="phone"
                class="input"
                @change="consent = true"
              />
              <span class="input-error" v-if="consent">{{ errors[0] }}</span>
            </ValidationProvider>
          </label>
          <label for="mail">
            <h4>{{ $t("step4.contact.mail") }}</h4>
            <ValidationProvider
              :rules="{required: phone && phone.length === 0, email: true}"
              v-slot="{ errors }"
              :disabled="!consent"
              :customMessages="{ required: $t('step4.contact.required')}"
            >
              <input
                type="text"
                id="mail"
                v-model="mail"
                name="mail"
                class="input"
                @change="consent = true"
              />
              <span class="input-error" v-if="consent">{{ errors[0] }}</span>
            </ValidationProvider>
          </label>
        </div>
      </ValidationObserver>
    </div>

    <div class="section" :class="$mq">
      <div class="title">{{ $t("step4.segment.title") }}</div>
      <div class="container inline center h-item-margin margin no-legend">
        <span class="check-frame">{{ $t(`step4.segment.b2b`) }}</span>
        <label for="isPro" class="switch">
          <input type="checkbox" id="isPro" name="isPro" v-model="isPro" />
          <span class="slider"></span>
        </label>
        <span class="check-frame">{{ $t(`step4.segment.b2c`) }}</span>
      </div>
    </div>

    <div class="section" :class="$mq">
      <div class="container inline center h-item-margin margin" @click="consent = !consent">
        <div class="check-button" :class="{active: consent}"></div>
        <div class="txt-left small grow">{{ $t(`step4.consent.text`) }}</div>
      </div>
    </div>

    <div class="button">
      <button @click="getResult()" class="stroke">{{ $t('validate') }}</button>
      <div class="error" v-if="error">{{ $t(`step4.${error}`) }}</div>
    </div>

    <div class="loader" v-if="loading">
      <SvgIcon class="icon" icon="loader"></SvgIcon>
    </div>
  </div>
</template>

<script>
import Providers from "./calculation/Providers";
import { mapGetters, mapState } from "vuex";
export default {
  data() {
    return {
      error: null,
      loading: false
    };
  },
  computed: {
    ...mapState("calculation", ["simulation", "area", "city"]),
    ...mapState("contact", ["civilities"]),
    ...mapState("energy", ["type"]),
    ...mapState("comparison", ["elecProducts", "gasProducts"]),
    civility: {
      get() {
        return this.$store.state.contact.civility;
      },
      set(value) {
        this.$store.commit("contact/setCivility", value);
      }
    },
    firstName: {
      get() {
        return this.$store.state.contact.firstName;
      },
      set(value) {
        this.$store.commit("contact/setFirstName", value);
      }
    },
    lastName: {
      get() {
        return this.$store.state.contact.lastName;
      },
      set(value) {
        this.$store.commit("contact/setLastName", value);
      }
    },
    phone: {
      get() {
        return this.$store.state.contact.phone;
      },
      set(value) {
        this.$store.commit("contact/setPhone", value);
      }
    },
    mail: {
      get() {
        return this.$store.state.contact.mail;
      },
      set(value) {
        this.$store.commit("contact/setMail", value);
      }
    },
    isPro: {
      get() {
        return this.$store.state.contact.isPro;
      },
      set(value) {
        this.$store.commit("contact/setIsPro", value);
      }
    },
    consent: {
      get() {
        return this.$store.state.contact.consent;
      },
      set(value) {
        this.$store.commit("contact/setConsent", value);
      }
    }
  },
  methods: {
    async getResult() {
      if (
        this.$store.state.middleware.isUuid ||
        (await this.$refs.observer.validate())
      ) {
        try {
          this.loading = true;
          if (!this.area || !this.city) {
            await this.$store.dispatch("calculation/getCity");
            await this.$store.dispatch("calculation/save");
          }

          await this.$store.dispatch("podium/getPodium");
        } catch (error) {
          console.log(error);
          this.loading = false;
          this.error = "error";
        }

        if (this.simulation) {
          try {
            await this.$store.dispatch("simulation/getSimulation");
            this.$store.dispatch("common/save");
            this.$store.dispatch("contact/save");
            // this.$store.dispatch("simulation/save");
            this.loading = false;
            this.$router.push({ name: "Simulation", query: this.$route.query });
          } catch (error) {
            console.log(error);
            this.loading = false;
            this.error = "error";
          }
        } else {
          try {
            await this.$store.dispatch("comparison/getComparison");
            this.$store.dispatch("common/save");
            this.$store.dispatch("contact/save");
            // this.$store.dispatch("comparison/save");
            this.loading = false;
            this.$router.push({ name: "Comparison", query: this.$route.query });
          } catch (error) {
            console.log(error);
            this.loading = false;
            if (
              (error =
                "no product found for given provider, postal code and customer type")
            )
              this.error = "mono-error";
            else this.error = "error";
          }
        }

        this.$store.commit("middleware/setIsUuid", false);
      }
    }
  },
  created() {
    if (this.$store.state.middleware.isUuid) {
      this.getResult();
    }

    if (!this.civilities.length) {
      this.$store.dispatch("contact/getCivilities", this.$i18n.locale);
    }
    window.scrollTo(0, 0);
  },
  components: { Providers }
};
</script>

<style lang="scss" scoped>
.city {
  margin: auto 10%;
  .grow {
    min-width: 250px;
    max-width: 400px;
    .input {
      width: 100%;
    }
  }
}

.check-button {
  width: 20px;
  height: 20px;
  border: 2px solid #888;

  &.radio {
    border-radius: 50%;
  }

  &.active {
    border: 2px solid #fdcb47;
    background: #fdcb47;
    position: relative;

    &::before {
      content: "";
      left: 0.4em;
      top: 0.1em;
      position: absolute;
      border-color: #fff;
      border-style: solid;
      border-width: 0 0.1em 0.1em 0;
      height: 0.8em;
      transform: rotate(45deg);
      width: 0.3em;
    }
  }
}

.small {
  font-size: 0.8rem;
}

.button .error {
  margin-top: 10px;
  color: #f58b1e;
  display: block;
}
</style>


// WEBPACK FOOTER //
// src/views/Contact.vue